"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var loadingSpinner_1 = require("./loadingSpinner");
exports.NetworkActivity = function (_a) {
    var showActivity = _a.showActivity, isActive = _a.isActive;
    if (showActivity && isActive) {
        return react_1.default.createElement(loadingSpinner_1.LoadingSpinner, null);
    }
    return null;
};
